import { IndicatorTiersEnum, IndicatorTiersType } from '@/api/rest/resources/types/IndicatorProduct';
import { RecommendationCardEnum, RecommendationCardType } from '@/api/rest/resources/types/recommendations';
import { RECOMMENDATION_CARD_COLORS } from '@/components/widgets/o/RecommendationCard/types';
import { Logger } from '@/lib/logs/logger';
import { resolveThemeColor } from '@/utils/resolveThemeColor';

type RecommendationCardStyle = {
  background: string;
  color: string;
};

type CardType = RecommendationCardType | IndicatorTiersType;

export const getStylesByCardType = (cardType: CardType): RecommendationCardStyle => {
  switch (cardType) {
    case RecommendationCardEnum.monetization:
      return {
        background: '#EBECFF',
        color: RECOMMENDATION_CARD_COLORS.monetization,
      };
    case RecommendationCardEnum.risk:
      return {
        background: '#F6D4C1',
        color: RECOMMENDATION_CARD_COLORS.risk,
      };
    case RecommendationCardEnum.resilience:
      return {
        background: '#E1FFB2',
        color: RECOMMENDATION_CARD_COLORS.resilience,
      };
    case RecommendationCardEnum.opportunity:
      return {
        background: '#D2E3D8',
        color: RECOMMENDATION_CARD_COLORS.opportunity,
      };
    case RecommendationCardEnum.insight:
      return {
        background: '#D2E3D8',
        color: RECOMMENDATION_CARD_COLORS.insight,
      };
    case IndicatorTiersEnum.free:
      return {
        background: '#E9E5DD',
        color: '#000000DE',
      };
    case IndicatorTiersEnum.add_on:
      return {
        background: '#DAEA21',
        color: '#000000DE',
      };
    case IndicatorTiersEnum.lite:
      return {
        background: '#B9EFFB',
        color: '#000000DE',
      };
    case IndicatorTiersEnum.pro:
      return {
        background: '#FFDD5F',
        color: '#000000DE',
      };
    default:
      Logger.error(`Card type "${cardType}" styles are not defined in getStylesByCardType()`);
      return { background: resolveThemeColor('transparent'), color: resolveThemeColor('transparent') };
  }
};
